
import Vue, {PropType} from 'vue'
import {  
  ParamDiff,
  ParamChange,
  PSetsDiff,
} from '@/types'
const _ = require('lodash');
export default Vue.extend({
  name: 'ModDiffView',
   data() {
    return {
      tab: null,
      changedHeaders : [
        {text : "Parameter Name", value: 'name', width: "1vw"},
        {text : "old value", value: "from_val", width: "100px"},
        {text : "new value", value: "to_val", width: "300px"}
      ]
    };
  },
  components :{
  },
  methods: {
    getColor(diff){      
      if (_.isEqual(diff.from_param,diff.to_param)) return 'black'
      else if(_.isEqual(diff.from_param,[]) || diff.from_param==='') return 'green'
      else if(_.isEqual(diff.to_param,[]) || diff.to_param==='') return 'red'
      else return 'orange'
    },
    
    /**allows us to insert whitespace into a string so it can be wrapped
     * by v-data-table correctly
    */
    getInsertBreaks(val: string,maxContinuous : number){
      let newVal  = ""
      let continuousCount = 0
      for(let index =0;index<val.length;index++){
        if(continuousCount>=maxContinuous){
          newVal+=" "
          continuousCount=0
        }
        if(val[index]===" "){
          continuousCount=0
        }
        continuousCount++
        newVal+=val[index]
      }
      return newVal
    },
    /**converts the arrays to a string with a space between entries
     * this is necessary to ensure the v-data-table can properly wrap the text
    */
    getDiffAsString(diff : number | Array<number> | Array<string>| undefined){
      if(typeof diff ==="object" && Array.isArray(diff)){                
        return Array.prototype.join.call(diff,", ")
      }else if(diff!==undefined){
        return String(diff)
      }else{
        return diff
      }
    },

    getDiffText(diffs : Array<ParamDiff>,from_sep : string,to_sep : string){
      let from_text : Array<string> = [] 
      let to_text : Array<string> = []      
      for(const diff of diffs){        
        if (diff.subdiff!=undefined){
          const subdiff = this.getDiffText(diff.subdiff,"","")
          from_text.push(subdiff[0])
          to_text.push(subdiff[1])
        }else{
          let color = this.getColor(diff)
          const from_diff_str = this.getDiffAsString(diff.from_param)
          const to_diff_str = this.getDiffAsString(diff.to_param)
          //if its empty we'll have an empty space which will get joined with the , and thus have a stray
          //comma
          if(from_diff_str!==""){
            from_text.push(`<span class="${color}--text">${from_diff_str}</span>`)
          }
          if(to_diff_str!==""){
            to_text.push(`<span class="${color}--text">${this.getDiffAsString(diff.to_param)}</span>`)
          }
        }
      }      
      return [from_text.join(from_sep),to_text.join(to_sep)]
    },
    /**
     * 
     * @param changedPSets the raw diffs
     * 
     * This function takes the raw diffs and returns an array of objects with the diffs resolved
     * so they can be nicely displayed in the table
     */
    makeNiceDiffs(changedPSets : Array<ParamChange>){
      let madeNice : Array<Object> = []
      for(const changedPSet of changedPSets){
        let from_sep = Array.isArray(changedPSet.from_val) ? ", " : ""
        let to_sep = Array.isArray(changedPSet.to_val) ? ", " : ""
        
        const diffText = this.getDiffText(changedPSet.diff,from_sep,to_sep)        
        const niceDiff = {
          name : changedPSet.name,
          from_val : diffText[0],
          to_val : diffText[1]
        }
        madeNice.push(niceDiff)
      }
      return madeNice
    },
    


  },
  computed: {
    

  },
  props: {
    psetDiffs : {type : Object as PropType<PSetsDiff>, required : false}
  }
  
})
